/* HUNTER — interacciones propias (prefijo hx-) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Texto partido en palabras ---------- */
  function initSplit(root) {
    root.querySelectorAll('[data-hx-split]:not([data-hx-split-ok])').forEach(function (el) {
      el.setAttribute('data-hx-split-ok', '');
      var i = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'hx-w';
              var inner = document.createElement('span');
              inner.style.setProperty('--hx-wi', i++);
              inner.textContent = part;
              w.appendChild(inner);
              frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            walk(child);
          }
        });
      };
      walk(el);
      el.classList.add('hx-split');
    });
  }

  /* ---------- Reveals (un solo observer) ---------- */
  var io = null;
  function initReveal(root) {
    var els = root.querySelectorAll('.hx-reveal, .hx-split, .hx-paso');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hx-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('hx-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-hx-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  function tickParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var host = el.parentElement;
      var r = host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var k = parseFloat(el.getAttribute('data-hx-parallax')) || 0;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * k * -100).toFixed(2) + 'px,0)';
    });
  }

  /* ---------- Foco de luz que sigue al cursor (hero) ---------- */
  function initSpot(root) {
    if (!finePointer) return;
    root.querySelectorAll('[data-hx-spot]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--hx-sx', ((e.clientX - r.left) / r.width) * 100 + '%');
        el.style.setProperty('--hx-sy', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* ---------- Tarjetas que se inclinan + brillo holográfico ---------- */
  function initTilt(root) {
    if (!finePointer) return;
    root.querySelectorAll('[data-hx-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-hx-tilt')) || 8;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        el.style.transform = 'rotateY(' + ((x - 0.5) * max).toFixed(2) + 'deg) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg)';
        el.style.setProperty('--hx-mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--hx-my', (y * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnet(root) {
    if (!finePointer) return;
    root.querySelectorAll('[data-hx-magnet]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + x * 0.18 + 'px,' + y * 0.3 + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCount(root) {
    root.querySelectorAll('[data-hx-count]').forEach(function (el) {
      var end = parseFloat(el.getAttribute('data-hx-count'));
      if (isNaN(end)) return;
      var dec = (String(end).split('.')[1] || '').length;
      if (!('IntersectionObserver' in window)) { el.textContent = end.toFixed(dec); return; }
      el.textContent = (0).toFixed(dec);
      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        var t0 = performance.now();
        var dur = 1600;
        (function step(t) {
          var p = Math.min(1, (t - t0) / dur);
          var v = end * (1 - Math.pow(1 - p, 4));
          el.textContent = v.toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  /* ---------- Escena sticky: paso activo ---------- */
  function initEscena(root) {
    root.querySelectorAll('.hx-escena').forEach(function (sec) {
      var steps = sec.querySelectorAll('.hx-escena__step');
      if (!steps.length || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            steps.forEach(function (s) { s.classList.remove('hx-activo'); });
            e.target.classList.add('hx-activo');
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
      steps[0].classList.add('hx-activo');
    });
  }

  /* ---------- Línea de progreso de los pasos ---------- */
  var lineas = [];
  function initPasos(root) {
    root.querySelectorAll('.hx-pasos__line').forEach(function (l) { if (lineas.indexOf(l) === -1) lineas.push(l); });
  }
  function tickPasos() {
    var vh = window.innerHeight;
    lineas.forEach(function (l) {
      var grid = l.parentElement;
      var r = grid.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height * 0.7);
      l.style.setProperty('--hx-progreso', Math.max(0, Math.min(1, p)).toFixed(3));
    });
  }

  /* ---------- Acordeones (FAQ y producto) ---------- */
  function initAcordeon(root) {
    root.querySelectorAll('.hx-faq__q:not([data-hx-ok])').forEach(function (btn) {
      btn.setAttribute('data-hx-ok', '');
      btn.addEventListener('click', function () {
        var item = btn.closest('.hx-faq__item');
        var abierto = item.classList.toggle('hx-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ---------- Guía de tamaños ---------- */
  function initTamanos(root) {
    root.querySelectorAll('.hx-tam').forEach(function (sec) {
      var tabs = sec.querySelectorAll('.hx-tam__tab');
      var pill = sec.querySelector('.hx-tam__pill');
      var card = sec.querySelector('.hx-tam__card');
      var panels = sec.querySelectorAll('.hx-tam__panel');
      function activar(i) {
        tabs.forEach(function (t, j) { t.classList.toggle('hx-activo', i === j); t.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.classList.toggle('hx-activo', i === j); });
        if (card) card.setAttribute('data-tam', tabs[i].getAttribute('data-tam'));
        if (pill) {
          pill.style.width = tabs[i].offsetWidth + 'px';
          pill.style.transform = 'translateX(' + tabs[i].offsetLeft + 'px)';
        }
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { activar(i); }); });
      if (tabs.length) {
        activar(0);
        window.addEventListener('resize', function () {
          var i = Array.prototype.findIndex.call(tabs, function (t) { return t.classList.contains('hx-activo'); });
          activar(Math.max(0, i));
        });
      }
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    root.querySelectorAll('[data-hx-producto]').forEach(function (sec) {
      if (sec.hasAttribute('data-hx-ok')) return;
      sec.setAttribute('data-hx-ok', '');
      var jsonEl = sec.querySelector('[data-hx-variantes]');
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var form = sec.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var btn = sec.querySelector('[data-hx-add]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var priceEl = sec.querySelector('[data-hx-price]');
      var compareEl = sec.querySelector('[data-hx-compare]');
      var saveEl = sec.querySelector('[data-hx-save]');
      var msg = sec.querySelector('.hx-prod__msg');
      var fmt = sec.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
      var txtAdd = sec.getAttribute('data-txt-add');
      var txtSold = sec.getAttribute('data-txt-sold');
      var txtAdded = sec.getAttribute('data-txt-added');

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',');
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          if (k.indexOf('comma') > -1) return withComma;
          if (k === 'amount_no_decimals') return Math.round(cents / 100);
          return v;
        });
      }

      function seleccion() {
        var opts = [];
        sec.querySelectorAll('[data-hx-option]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          opts.push(c ? c.value : null);
        });
        return opts;
      }

      function actualizar() {
        var opts = seleccion();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        // marcar pastillas agotadas para la combinación actual
        sec.querySelectorAll('[data-hx-option]').forEach(function (g, gi) {
          g.querySelectorAll('.hx-prod__pill').forEach(function (p) {
            var val = p.querySelector('input').value;
            var test = opts.slice(); test[gi] = val;
            var m = variants.find(function (x) { return x.options.every(function (o, i) { return o === test[i]; }); });
            p.classList.toggle('hx-agotado', !m || !m.available);
          });
          var lbl = g.querySelector('[data-hx-option-value]');
          if (lbl) lbl.textContent = opts[gi] || '';
        });
        if (!v) {
          if (btn) { btn.disabled = true; btnTxt.textContent = txtSold; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        var showCompare = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.textContent = showCompare ? money(v.compare_at_price) : ''; compareEl.hidden = !showCompare; }
        if (saveEl) {
          saveEl.hidden = !showCompare;
          if (showCompare) saveEl.textContent = saveEl.getAttribute('data-label').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
        }
        if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? txtAdd : txtSold; }
        // Solo cambia la foto si la variante nueva tiene una foto distinta a la anterior
        if (v.featured_media && sec._hxMedia !== undefined && sec._hxMedia !== v.featured_media) {
          var t = sec.querySelector('.hx-prod__thumb[data-media-id="' + v.featured_media + '"]');
          if (t) t.click();
        }
        sec._hxMedia = v.featured_media;
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        var sticky = document.querySelector('[data-hx-sticky-price]');
        if (sticky) sticky.textContent = money(v.price);
      }

      sec.querySelectorAll('[data-hx-option] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      // Galería
      var main = sec.querySelector('.hx-prod__main img');
      sec.querySelectorAll('.hx-prod__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main || t.classList.contains('hx-activo')) return;
          sec.querySelectorAll('.hx-prod__thumb').forEach(function (o) { o.classList.remove('hx-activo'); });
          t.classList.add('hx-activo');
          main.classList.add('hx-cambiando');
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.srcset = t.getAttribute('data-srcset') || '';
            main.alt = t.getAttribute('data-alt') || '';
            main.onload = function () { main.classList.remove('hx-cambiando'); };
            setTimeout(function () { main.classList.remove('hx-cambiando'); }, 500);
          }, 200);
        });
      });

      // Cantidad
      var qty = sec.querySelector('.hx-prod__qty input');
      sec.querySelectorAll('[data-hx-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-hx-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      // Añadir al carrito sin salir de la página (con respaldo al envío normal)
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!btn || btn.disabled) return;
          btn.disabled = true;
          if (msg) msg.textContent = '';
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var fd = new FormData(form);
          if (cart && cart.getSectionsToRender) {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              btn.disabled = false;
              if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
              btnTxt.textContent = txtAdded;
              setTimeout(function () { btnTxt.textContent = txtAdd; }, 1800);
              if (cart && cart.renderContents) {
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                cart.renderContents(res);
              } else {
                window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              }
            })
            .catch(function () { btn.disabled = false; form.submit(); });
        });
      }

      // Barra fija de compra
      var stickyBar = document.querySelector('.hx-prod__sticky');
      if (stickyBar && btn && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          var e = en[0];
          stickyBar.classList.toggle('hx-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        o.observe(btn);
        var sb = stickyBar.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { if (!btn.disabled) form.requestSubmit ? form.requestSubmit() : form.submit(); }, 450);
        });
      }

      actualizar();
    });
  }

  /* ---------- Bucle de scroll ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { tickParallax(); tickPasos(); ticking = false; });
  }

  function initAll(root) {
    initSplit(root);
    initReveal(root);
    initParallax(root);
    initSpot(root);
    initTilt(root);
    initMagnet(root);
    initCount(root);
    initEscena(root);
    initPasos(root);
    initAcordeon(root);
    initTamanos(root);
    initProducto(root);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Editor de Shopify: re-iniciar al cargar/editar una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
